import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'under-construction',
    template:   `
                <div style="padding:20px;height:100%" id="under_construction">
                    <div class="blank-slate-pf " style="height:100%"  >
                        <div class="blank-slate-pf-icon">
                            <mdb-icon fas icon="pencil-ruler" class="fa-2x"></mdb-icon>
                        </div>
                        <h1>{{ 'administration_underConstruction_label' | translate }}</h1>
                        <p>{{ 'administration_checkBackSoon_label' | translate }}</p>
                    </div>
                </div>
                `
})

export class UnderConstructionComponent implements OnInit {

    
    constructor() { }

    ngOnInit() { 
        this.setUI()
    }
    setUI(){
        let h = window.innerHeight
        document.getElementById('under_construction').style.height = (h-60) + 'px';
    }
}